module.exports = __webpack_public_path__ + "img/9_60.57e8718f.png";